import React from 'react';
import { addMaskCep } from '../../../utils/formatValues';

import * as S from './styles';

function AddressCard({ addressType, title, endereco }) {
    const emptyMessage = 'Não definido';
    const cep = addMaskCep(endereco.cep);
    return (
        <S.CardContainer>
            <S.Title>{title}</S.Title>
            <S.AddressType>{addressType}</S.AddressType>
            {endereco.cep ? (
                <>
                    <S.AlignAddress>
                        <span>
                            {endereco.logradouro}, {endereco.numero}
                        </span>
                        <span> {endereco.complemento}</span>
                    </S.AlignAddress>
                    <S.AlignAddress>
                        <span>{endereco.bairro?.nome}, </span>
                        <span>Cep: {cep}</span>
                    </S.AlignAddress>
                    <S.AlignAddress>
                        <span>{endereco.municipio?.nome} - </span>
                        <span>{endereco.siglaUf}</span>
                    </S.AlignAddress>
                </>
            ) : (
                <div>{emptyMessage}</div>
            )}
        </S.CardContainer>
    );
}

export default AddressCard;
